module.exports = __webpack_public_path__ + "components/weather-icon/static/daysnowshowers-c93b2302ae17173472f2cc41d6b51204.svg";